baJS.searchPage = {
	q:null,
	postData:[],
	helpData:[],
	per:6,
	hidden:0,
	searchTime:0,
	postType:'post',
	sorttype:"t",
	sortingTimeout:null,
	init:function(){
		if($("#ba-post-stage .ba--pgitem").length > 0){
			$(".ba-post--loadmore").show();
			//this.calcDelta();
		}
	},
	fetchResults:function( update_history = true ){
		var thisobj = this;
		var searchTerm = thisobj.q;
		//var searchPostType = thisobj.postType;
		$(".ba-search--page--results").html('<div class="search-context" tabindex="0"><p class="bds--small">Searching<span>.</span><span>.</span><span>.</span></p></div>');
		//$("#home-search-form .clear-search").css("display", "block");
		//$(".search-context").focus();
		$('html, body').animate({scrollTop: $("#ba-page--search-form").offset().top - 50 - $("header").height() }, 400);
		$(".ba-post--loadmore").hide();
		this.searchTime = new Date().getTime();
		$.ajax({
			type: 'POST',
			url: ajaxfullurl,
			data: {
				'action': 'spruce_post_search',
				'search' : searchTerm,
			},
			success: function (result) {
				thisobj.postData = result.posts;
				thisobj.helpData = result.help;
				thisobj.buildResults();

				// Update History - only when _not_ changing history
				if ( update_history ) {
					var search_url = new URL(window.location);
					search_url.searchParams.set('q', searchTerm);
					window.history.pushState({}, '', search_url);
				}

				// Analytics Data
				var contextData = {
					page_section: 'spruce',
					page_sub_section: 'resource center',
					page_title: 'search results',
				};
				_dd('page_load', contextData);

				//$("#most-recent").prop('checked', true);
			},
			error: function () {
				$(".ba-search--page--results").html('<div class="search-context" tabindex="0"><p class="bds--small">Something went wrong. Try again or <a href="#" class="action--reset-search">Show All</a></p></div>');
				$(".ba-post--loadmore").hide();
			}
		});
	},
	buildResults:function(){
		var thisobj = this;
		var returndata = [];
		var totalresults = 0;
		var postDataForBuild;
		var formalName;
		switch(this.postType){
			case 'post':
				postDataForBuild = thisobj.postData;
				formalName = 'Resource Center';
				break;
			case 'help':
				postDataForBuild = thisobj.helpData;
				formalName = 'Help Center';
				break;
		}
		totalresults = postDataForBuild.length;
		
		
		for(var i=0; i < totalresults; i++){
			if(postDataForBuild[i].hasvideo == 'true') {
				var videoBadgeCode = '<div class="has-video-badge--title"><p>Video</p></div>';
			} else {
				var videoBadgeCode = '';
			}

			var ariaHidden = 'false';
			if(i >= 6){
				ariaHidden = 'true';
			}
			returndata.push(''+
				'<a href="'+postDataForBuild[i].url+'" data-click=\'{"loc":"b","nm":"'+postDataForBuild[i].dt+'"}\' class="ba--pgitem featured-card" data-t="'+postDataForBuild[i].t+'" data-p="'+postDataForBuild[i].p+'" aria-hidden="'+ariaHidden+'">'+
					'<h3 class="category-label">'+postDataForBuild[i].cat+'</h3>'+
					'<h2 class="post-title bds--small">'+postDataForBuild[i].title+'</h2>'+
					'<p>'+postDataForBuild[i].ex+'</p>'+videoBadgeCode+
				'</a>');
		}
		var nowish =  new Date().getTime();
		var remainder = Math.floor(500 - (nowish - this.searchTime));
		$("#ba-search-count span:nth-of-type(1)").text(totalresults);
		$("#ba-search-count span:nth-of-type(3)").text(formalName);
		this.hidden = totalresults - this.per;
		if(totalresults == 1){
			$(".is-the-count-plural").hide();
		} else {
			$(".is-the-count-plural").show();
		}
		setTimeout(function(){
			if(returndata.length > 0){
				$(".ba-search--page--results").html(returndata.join("\r"));
				thisobj.init();
				//$(".search-result-metrics").slideDown(200);
				//$(".ba-search--page--results").find(".ba--pgitem:first-of-type").focus();
			} else {
				//$(".search-result-metrics").slideUp(200);
				$(".ba-search--page--results").html($("#search-page-no-results").html());
			}
			if(returndata.length - thisobj.per > 0){
				$(".ba-post--loadmore").show();
			} else {
				$(".ba-post--loadmore").hide();
			}
		}, remainder);
	},
	calcPer:function(){
		this.per = 3;
	},
	loadMore:function(){
		//console.log("Loading more...");
		$(".ba-search--page--results").find(".ba--pgitem").removeClass("first-focus");
		this.calcPer();
		var thePer = this.per;
		if(this.hidden > 0){
			var hiddenPosts = $(".ba-search--page--results").find(".ba--pgitem[aria-hidden=true]").slice(0, this.per);
			var scrollTarget = $(".ba-search--page--results").find(".ba--pgitem[aria-hidden=false]").last();
			var scrollOffset = scrollTarget.height();
			var totalToShow = hiddenPosts.length;
			if(totalToShow > 0){
				var delay = 0;
				var fadeDelay = 150;
				hiddenPosts.each(function(){
					var item = $(this);
					setTimeout(function(){ item.attr("aria-hidden", "false") }, delay);
					if(delay == 0){ 
						item.addClass("first-focus");
					}
					delay += fadeDelay;
				});
				setTimeout(function(){ 
					if($(".ba-search--page--results").find(".ba--pgitem[aria-hidden=true]").length <= 0){
						$(".ba-post--loadmore").fadeOut(600);
					}
				}, delay + 100);
				$('html, body').animate({scrollTop: scrollTarget.offset().top + (scrollOffset-$("header").height()) }, 400);
				//$(".ba-search--page--results").find(".ba--pgitem.first-focus").focus();
				//console.log($(".ba-search--page--results").find(".ba--pgitem[aria-hidden=true]").length, thePer);
			} else {
				$(".ba-post--loadmore").fadeOut(600);
			}
		}
	},
	changeSort:null,
	changePostType:function(){
		var allposts = $(".ba-search--page--results a");
		if(allposts.length === 0){
			return false;
		}
		
		
		$(".ba-search--page--results").html('<div class="search-context" tabindex="0"><p class="bds--small">Sorting<span>.</span><span>.</span><span>.</span></p></div>');
		var thesort = this.sorttype;
		allposts.sort(function(a, b){
			return ($(b).data(thesort)) < ($(a).data(thesort)) ? -1 : 1;
		});
		clearTimeout(this.sortingTimeout);
		this.sortingTimeout = setTimeout(function(){
			$(".ba-search--page--results").html(allposts);
		}, 400);
	}
};

$(document).ready(function ($) {
	window.addEventListener('popstate', function (e) {
		if ( e.state != null ) {

			// Get query var
			var query_string 	= window.location.search;
			var url_params 		= new URLSearchParams( query_string );
			var search_query 	= url_params.get( 'q' );

			// Update obj query var
			baJS.searchPage.q = search_query;

			// Update input value
			$('#ba-page-search-field').val( search_query );

			// Fetch new results (Without history tracking)
			baJS.searchPage.fetchResults( false );
		}
	});
});

$(document)
.on("click", ".ba-page--search--contact-switch .option--1", function(e){
  e.preventDefault();
  $(this).parents(".ba-page--search--contact-switch").removeClass("choice-other");
	baJS.searchPage.postType = 'post';
	baJS.searchPage.buildResults();
})
.on("click", ".ba-page--search--contact-switch .option--2", function(e){
  e.preventDefault();
  $(this).parents(".ba-page--search--contact-switch").addClass("choice-other");
	baJS.searchPage.postType = 'help';
	baJS.searchPage.buildResults();
})
;
